// Security constants
export const HCAPTCHA_SITE_KEY = "0cf4b034-aa66-4ecc-ab96-2b94604e3d18"; // Your hCaptcha site key

// Authentication constants
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_REQUIREMENTS = "Password must be at least 8 characters with uppercase, lowercase, number, and special character";

// Rate limiting constants
export const MAX_LOGIN_ATTEMPTS = 5;
export const LOGIN_ATTEMPT_WINDOW = 15 * 60 * 1000; // 15 minutes

// Logo constants with WebP optimization
export const LOGO_SRC = "https://bohostyleco.com/lovable-uploads/bohostyleco-logo-1000x600-bl.png";
export const LOGO_WEBP = "https://bohostyleco.com/lovable-uploads/bohostyleco-logo-1000x600-bl.webp";
export const NAV_LOGO_LIGHT = "/lovable-uploads/bohologo-topnavLIGHT.png";
export const NAV_LOGO_DARK = "/lovable-uploads/bohologo-topnavDARK.png";

// WebP support detection
export const supportsWebP = (() => {
  if (typeof window === 'undefined') return false;
  const canvas = document.createElement('canvas');
  canvas.width = 1;
  canvas.height = 1;
  return canvas.toDataURL('image/webp').startsWith('data:image/webp');
})();